<template>
	<NavSidebarLayout
		:show-left-sidebar="showLeftSidebar"
	>
		<router-view />
	</NavSidebarLayout>
</template>

<script>
import NavSidebarLayout from "./NavSidebar/NavSidebarLayout";

export default {
	name: "StandardAppLayout",
	components: {
		NavSidebarLayout,
	},
	props: {
		showLeftSidebar: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="scss">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	height: 100%;
}
</style>
